import styled from 'styled-components/macro';

export const HeaderWrapper = styled.div`
  margin-bottom: 24px;
  max-width: 492px;
  width: 100%;
`;
